import Vue from 'vue'
import CookieControl from './CookieControl.vue';
import cookies from  './prepare-cookies'

Vue.config.productionTip = false
Vue.prototype.$cookies = cookies;

const ccLocale = window.cc_locale || 'en'

new Vue({
  el: '#ccapp',
  props: ['locale'],
  render: h => h(CookieControl, {props: {locale: ccLocale}}),
})

// .$mount('#ccapp')
